<template>
  <vs-popup
    title="Envoyer la demande vers Service Now"
    :active.sync="isPromptActiveLocal"
  >
    <vs-row>
      <vs-col vs-w="12">
        <p>Titre <b style="color: #ff6141">*</b></p>
        <vs-input
          v-model="form.short_description"
          class="w-full"
        /><br />
      </vs-col>
      <vs-col vs-w="12">
        <p class="mt-2">Contenu <b style="color: #ff6141">*</b></p>
        <vs-textarea rows="3" v-model="form.description" />
      </vs-col>

      <vs-col vs-w="12">
        <p class="mt-2">Commentaires</p>
        <vs-textarea rows="3" v-model="form.comments" />
      </vs-col>
      <!-- <vs-col vs-w="12">
        <p class="mt-2">Priorité <b style="color: #ff6141">*</b></p>
        <v-select
          :reduce="(rep) => rep.id"
          class="w-full"
          label="name"
          v-model="form.priority"
          :options="priorities"
        ></v-select>
      </vs-col> -->

      <vs-divider>Fichiers joins</vs-divider>
      <vs-col vs-w="12">
        <div class="upload-img mt-1 mb-4">
          <input
            type="file"
            class="hidden"
            ref="uploadimgInput"
            @change="updateCurrimg"
            accept="*/*"
          />
          <vs-button :disabled="form.img_names && form.img_names.length == 0 ? false : true" size="small" @click.prevent="$refs.uploadimgInput.click()"
            >Joindre un fichier</vs-button
          >
        </div>

        <template v-if="form.img && form.img.length > 0">
          <h5>Fichier joints</h5>
          <div v-for="(img, index) in form.img" :key="index">
            <div class="modify-img flex justify-between mt-5">
              <div class="mail__attachment">
                <vs-chip color="grey" class="ml-2 mr-3 cursor-pointer">
                  <vs-avatar icon="cloud_download" />
                  {{ form.img_names[index] }}
                </vs-chip>
              </div>
              <vs-button
                size="small"
                type="border"
                color="danger"
                @click.prevent="updateCurrimgSupprimer(form.img_names[index])"
                >Supprimer</vs-button
              >
            </div>
          </div>
        </template>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col vs-w="12" type="flex">
        <vs-button :disabled="isFormValid() ? false : true"
          color="primary"
          @click="sendToServiceNow()"
          class="mt-4 mr-2"
          type="filled"
          >Soumettre</vs-button
        >
        <vs-button
          color="primary"
          class="mt-4"
          type="border"
          @click="closeForm()"
          >Annuler</vs-button
        >
      </vs-col>
    </vs-row>
  </vs-popup>
</template>

<script>
let base_self;
export default {
  name: "sendToServiceNow",
  props: {
    isPromptActive: {
      type: Boolean,
      required: true,
    },
    info: {
      type: Object,
      default: () => {},
    },
    callbacksendToServiceNow: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    // priorities: [
    //   { id: 1, name: "Haute" },
    //   { id: 2, name: "Moyenne" },
    //   { id: 3, name: "Basse" },
    // ],
    form: {},
    error: false,
  }),
  watch: {
    isPromptActive(val) {
      if (val) {
        this.form = this.info;
      } else {
        this.form = {};
      }
      if (!val) return;
    },
  },
  computed: {
    isPromptActiveLocal: {
      get() {
        return this.isPromptActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closePrompt");
        }
      },
    },
  },
  methods: {
    isFormValid(){
      return this.form.description !== "" && this.form.short_description !== "";
    },
    closeForm() {
      this.$emit("closePrompt");
    },
    sendToServiceNow() {
      this.callbacksendToServiceNow(this.form);
      this.$emit("closePrompt");
    },

    validateEmail(email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    updateCurrimg(input) {
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader();
        reader.onload = (e) => {
          console.log(base_self.form);
          base_self.form.img_names.push(input.srcElement.files[0].name);
          base_self.form.img.push(e.target.result);
          base_self.form.files.push(this.$refs.uploadimgInput.files[0]);
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    updateCurrimgSupprimer(img_name) {
      var length = this.form.img_names ? this.form.img_names.length : 0;
      for (let iuoy = 0; iuoy < length; iuoy++) {
        var item = this.form.img_names[iuoy];
        if (img_name === item) {
          this.form.img_names.splice(iuoy, 1);
          this.form.img.splice(iuoy, 1);
          this.form.files.splice(iuoy, 1);
          break;
        }
      }
    },
  },
  created() {
    base_self = this;
  },
};
</script>

<style lang="scss" scoped>
</style>
